import { c as _c } from "react/compiler-runtime";
import { Maybe } from '@/utils/types';
import { useTranslation } from 'react-i18next';
interface Props {
  value: Maybe<string>;
}
export function Model(t0) {
  const $ = _c(12);
  const {
    value
  } = t0;
  const {
    t
  } = useTranslation("career");
  switch (value) {
    case "onsite":
      {
        let t1;
        if ($[0] !== t) {
          t1 = t("model.onsite");
          $[0] = t;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
    case "remote":
      {
        let t1;
        if ($[2] !== t) {
          t1 = t("model.remote");
          $[2] = t;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    case "hybrid":
      {
        let t1;
        if ($[4] !== t) {
          t1 = t("model.hybrid");
          $[4] = t;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        return t1;
      }
    case "onsiteHybrid":
      {
        let t1;
        if ($[6] !== t) {
          t1 = t("model.onsiteHybrid");
          $[6] = t;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        return t1;
      }
    case "hybridRemote":
      {
        let t1;
        if ($[8] !== t) {
          t1 = t("model.hybridRemote");
          $[8] = t;
          $[9] = t1;
        } else {
          t1 = $[9];
        }
        return t1;
      }
    case "onsiteRemote":
      {
        let t1;
        if ($[10] !== t) {
          t1 = t("model.onsiteRemote");
          $[10] = t;
          $[11] = t1;
        } else {
          t1 = $[11];
        }
        return t1;
      }
    default:
      {
        return null;
      }
  }
}